import React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import SearchIcon from '@mui/icons-material/Search'

const CustomSearchInput = ({ handleChange, value, onclick }) => {
    return (
        <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined" className='custom-search-input'>
            <OutlinedInput
                sx={{ height: '35px' }}
                id="outlined-adornment-weight"
                value={value}
                onChange={handleChange}
                endAdornment={<InputAdornment position="end"><SearchIcon sx={{ fontSize: 25, cursor: 'pointer' }} onClick={() => onclick()} /></InputAdornment>}
                aria-describedby="outlined-weight-helper-text"
                inputProps={{
                    'aria-label': 'weight',
                }}
            />
        </FormControl>
    );
};

export default CustomSearchInput;